// extracted by mini-css-extract-plugin
module.exports = {"bottomLeftMargin":"BasicInformationQuestionSetCheckbox_bottomLeftMargin__2K634","leftMargin":"BasicInformationQuestionSetCheckbox_leftMargin__3I2ve"};